/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sprachanforderungen_EnInputs */

const de_sprachanforderungen_en = /** @type {(inputs: Sprachanforderungen_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Englische Sprachanforderungen`)
};

/** @type {(inputs: Sprachanforderungen_EnInputs) => LocalizedString} */
const en_sprachanforderungen_en = () => /** @type {LocalizedString} */ ('sprachanforderungen_en')

/**

* @param {Sprachanforderungen_EnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sprachanforderungen_en = /** @type {((inputs?: Sprachanforderungen_EnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sprachanforderungen_EnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sprachanforderungen_en(inputs)
	return en_sprachanforderungen_en(inputs)
});